<label class="select-label">{{ label }} <sup *ngIf="required">*</sup></label>
<p *ngIf="subtitle" class="field-subtitle">{{ subtitle }}</p>
<div class="select select-input" [ngClass]="{ invalid: invalid, 'no-formControlborder': noFormControlBorder }" (click)="toggleDropdown()" #dropreference>
    <ul>
        <li [class]="{ placeholder: !value && placeholder }">{{ !value ? placeholder : value.label }} <mat-icon class="icon icon-caret-down"></mat-icon></li>
    </ul>
    <app-select-dropdown-v2 [reference]="dropreference" #dropdown>
        <div class="select no-margin select-dropdown">
            <ul>
                <li class="hover" *ngFor="let option of options" (click)="select(option)">{{ option.label }}</li>
            </ul>
        </div>
    </app-select-dropdown-v2>
</div>
<div *ngIf="displayMessages" class="messages">
    <ng-content selector="app-form-error"></ng-content>
    <ng-content selector="app-form-success"></ng-content>
</div>
